import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { resolveOAuthRedirectUri, hubOriginFromRedirect } from '../util/oauth-hub.util';

@Injectable({ providedIn: 'root' })
export class MicrosoftOAuthService {
    private clientId = (environment as any).microsoftClientId || '';
    private tenantId = (environment as any).microsoftTenantId || 'common';

    openAuthPopup(): Promise<{ provider_id: string; email: string; name: string }> {
        return new Promise((resolve, reject) => {
            // Redirect fijo al hub central por TLD (autorizado una vez en Azure).
            const redirectUriRaw = resolveOAuthRedirectUri('microsoft-callback');
            const redirectUri = encodeURIComponent(redirectUriRaw);
            const hubOrigin = hubOriginFromRedirect(redirectUriRaw);
            // El origin del tenant viaja en state para el postMessage de vuelta.
            const tenantOrigin = window.location.origin;
            const state = encodeURIComponent(`login|${tenantOrigin}`);
            const scope = encodeURIComponent('openid profile email');
            const url = `https://login.microsoftonline.com/${this.tenantId}/oauth2/v2.0/authorize?client_id=${this.clientId}&response_type=code&redirect_uri=${redirectUri}&scope=${scope}&response_mode=query&state=${state}`;

            const popup = window.open(url, 'microsoft-oauth', 'width=500,height=600,scrollbars=yes');
            if (!popup) {
                reject(new Error('Popup blocked'));
                return;
            }

            const handler = (event: MessageEvent) => {
                // El mensaje llega desde el hub central (no desde el propio origin).
                if (event.origin !== hubOrigin && event.origin !== window.location.origin) return;
                if (event.data?.type === 'MICROSOFT_OAUTH_SUCCESS') {
                    window.removeEventListener('message', handler);
                    resolve(event.data);
                } else if (event.data?.type === 'MICROSOFT_OAUTH_ERROR') {
                    window.removeEventListener('message', handler);
                    reject(new Error(event.data.error));
                }
            };

            window.addEventListener('message', handler);
            setTimeout(() => {
                window.removeEventListener('message', handler);
                reject(new Error('Timeout'));
            }, 120000);
        });
    }
}
